/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ResolvedCommentIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Resolved Comment',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M30 2H6a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h2v8.793a.5.5 0 0 0 .854.354L18 26h12a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4Zm-4.204 7.722-8.658 10.93a.883.883 0 0 1-1.34.076l-5.53-5.249a.956.956 0 0 1-.007-1.32l.008-.008 1.286-1.263a.883.883 0 0 1 1.278-.008l.008.008 3.234 3.183 6.9-8.722a.877.877 0 0 1 1.26-.147l.017.014 1.415 1.177a.971.971 0 0 1 .129 1.329Z"
    />
  </svg>`;
};
